import { combineReducers } from 'redux'

import ports from './ports'

const reducer = combineReducers({ ports })

export default reducer
